import { Plugin } from '@console/plugin-sdk';

const plugin: Plugin<any> = [];

export default plugin;
